/**
 * GEM ENTERTAINMENT — French content (single source of truth)
 *
 * IMPORTANT: All user-facing copy lives here. Components must NOT hardcode text.
 * To add English later, duplicate this file as `en.js` and translate the values,
 * then wire a lang switch that picks between `fr` and `en`. The structure must
 * stay identical between languages so a swap is trivial.
 */

const fr = {
  meta: {
    title: "GEM Entertainment — Agence de production événementielle nouvelle génération",
    description:
      "GEM Entertainment fusionne mode, sport, culture urbaine et philanthropie pour créer des expériences immersives et prestigieuses. Découvrez l'Expo Streetwear & Sneaker Culture.",
    ogTitle: "GEM Entertainment — Nous créons les traditions de demain",
    ogDescription:
      "Agence de production événementielle nouvelle génération. Mode, sport, culture urbaine, philanthropie.",
  },

  nav: {
    home: "Accueil",
    events: "Événements",
    streetwearTab: "Streetwear™",
    beautyTab: "Beauty™",
    editions: "Éditions",
    partners: "Partenaires",
    cta: "Devenir partenaire",
    menuOpen: "Ouvrir le menu",
    menuClose: "Fermer le menu",
    backToHome: "Retour à l'accueil",
  },

  hero: {
    eyebrow: "Haute Couture Urbaine",
    headline: "NOUS CRÉONS LES TRADITIONS DE DEMAIN",
    subtitle:
      "GEM ENTERTAINMENT est une agence de production événementielle de nouvelle génération. Nous fusionnons la mode, le sport, la culture urbaine et la philanthropie pour concevoir des expériences immersives et marquantes au cœur des espaces les plus prestigieux.",
    cta: "Découvrir nos expériences",
    scrollHint: "Défiler",
  },

  expo: {
    eyebrow: "PROCHAINEMENT",
    title: "EXPO STREETWEAR & SNEAKERS CULTURE™",
    dateLine: "Cet Automne · Édition Annuelle Officielle",
    body:
      "Rejoignez le plus grand rassemblement de la culture de la rue. Pendant deux jours, un espace d'exception se transforme en un festival immersif unique. Parcourez un marché sélect de 46 créateurs indépendants et friperies de luxe locaux. Explorez notre musée éphémère de la chaussure de collection, présentant des pièces vintage mythiques sous vitrines blindées. Vibrez au rythme du grand tournoi de basketball en direct sur le terrain mobile, animé par des personnalités surprises, et assistez à la création d'une fresque monumentale en direct par des artistes de renom !",
    cta: "Réserver mon accès exclusif",
    soonModalTitle: "Billetterie bientôt disponible",
    soonModalBody:
      "La vente d'accès ouvre cet automne. Inscrivez-vous via nos partenaires sociaux pour être prévenu·e en avant-première.",
    soonModalClose: "Compris",
    pillars: [
      { label: "Créateurs & friperies", value: "46" },
      { label: "Jours de festival", value: "2" },
      { label: "Tournois live", value: "1" },
      { label: "Fresque monumentale", value: "1" },
    ],
    visualIntent: "Modèle Gen Z streetwear sous néons violets et roses, ambiance club haut de gamme",
  },


  streetwear: {
    eyebrow: "Résidence Octobre",
    title: "EXPO STREETWEAR & SNEAKER CULTURE™",
    subtitle: "L'ÉLÉVATION DE LA CULTURE URBAINE",
    intro:
      "GEM Entertainment™ Inc. ne crée pas d'événements ; notre maison de production implante des résidences culturelles et des franchises d'élite au cœur de la métropole. Nous redéfinissons les standards de l'industrie en fusionnant, au sein d'un même écosystème, le sport de performance, la haute couture urbaine et l'art contemporain le plus raffiné.",
    blocks: [
      {
        title: "L'EXCLUSIVITÉ DU LIEU",
        body:
          "Chacune de nos productions prend possession de La Nesra à Montréal. Transformés pour l'occasion en galeries d'art éphémères monumentales, nos espaces sont pensés pour offrir une immersion physique et visuelle totale à une communauté sélective de passionnés, de créateurs indépendants et de hauts dirigeants corporatifs.",
      },
      {
        title: "NOTRE ENGAGEMENT ÉTHIQUE : UNE CHARTE 100 % SANS ALCOOL",
        body:
          "Parce que le prestige n'a pas besoin de compromis, GEM Entertainment™ Inc. impose un environnement d'affaires et de célébration entièrement sans alcool. En remplaçant les spiritueux traditionnels par un protocole de mixologie botanique fine, de bar à mocktails hydratants et de cafés de spécialité, nous garantissons un écosystème sain, sécuritaire et hautement protecteur pour la réputation de nos partenaires et de nos sponsors.",
      },
      {
        title: "L'IMPACT PHILANTHROPIQUE DURABLE",
        body:
          "La responsabilité sociale est le pilier central de notre modèle d'affaires. À travers nos encans silencieux d'œuvres exclusives et nos activations sportives participatives au sol, GEM Entertainment™ Inc. s'associe de façon transparente à une fondation environnementale d'élite de la métropole. 100 % des bénéfices de ces initiatives sont directement reversés pour financer la plantation d'arbres et lutter contre les îlots de chaleur à Montréal.",
      },
    ],
    tagline: "GEM Entertainment™ Inc. — La pureté au service de la culture et des affaires",
    contact: {
      eyebrow: "Candidature",
      title: "CAPTUREZ LE MARCHÉ DE LA MÉTROPOLE",
      body:
        "Vous êtes un designer indépendant, une friperie haut de gamme ou une marque visionnaire ? Les places pour notre Creators Market™ sont strictement limitées à seulement 46 emplacements standardisés afin de garantir l'exclusivité absolue et éliminer toute concurrence interne. Remplissez notre formulaire de candidature simplifiée. Notre service commercial communiquera avec votre bureau de direction en moins de 48 heures.",
      programLabel: "Creators Market™",
      categoryOptions: [
        "Marque de vêtements",
        "Friperie",
        "Accessoires",
        "Artiste",
        "Sponsor Corporatif",
      ],
    },
  },

  beauty: {
    eyebrow: "Résidence Novembre",
    title: "BEAUTY WELLNESS WEEK-END™",
    subtitle: "L'ÉVEIL DE LA SÉRÉNITÉ URBAINE",
    intro:
      "GEM Entertainment™ Inc. ne crée pas d'événements ; notre maison de production implante des résidences culturelles et des franchises d'élite au cœur de la métropole. Nous redéfinissons les standards de l'industrie en fusionnant, au sein d'un même écosystème, la science du bien-être, la haute technologie clinique et l'art absolu de prendre soin de soi.",
    blocks: [
      {
        title: "L'EXCLUSIVITÉ DU LIEU",
        body:
          "Chacune de nos productions prend possession de La Nesra à Montréal. Transformés pour l'occasion en sanctuaires minimaux et thermaux monumentaux, nos espaces sont pensés pour offrir une immersion physique, auditive et visuelle totale à une communauté sélective de passionnés, d'experts et de hauts dirigeants corporatifs.",
      },
      {
        title: "NOTRE ENGAGEMENT ÉTHIQUE : UNE CHARTE 100 % SANS ALCOOL",
        body:
          "Parce que le prestige n'a pas besoin de compromis, GEM Entertainment™ Inc. impose un environnement d'affaires et de ressourcement entièrement sans alcool. En remplaçant les spiritueux traditionnels par un protocole de mixologie botanique fine, de bar à mocktails hydratants et de thés de spécialité, nous garantissons un écosystème sain, sécuritaire et hautement protecteur pour la réputation de nos partenaires et de nos sponsors.",
      },
      {
        title: "L'IMPACT ÉCONOMIQUE ET LE REFUGE DE FIN D'ANNÉE",
        body:
          "Le Beauty Wellness Week-end™ est conçu comme un carrefour commercial d'élite stratégiquement positionné avant la période des Fêtes. Dans le calme absolu de notre havre, profitez de ce moment de décompression pour devancer la frénésie des centres commerciaux et réaliser vos achats de cadeaux de Noël en toute sérénité. Offrir le soin, la haute cosmétique et le prestige devient un acte réfléchi, paisible et d'un standing incomparable.",
      },
    ],
    tagline: "GEM Entertainment™ Inc. — La pureté au service de la culture et des affaires.",
    contact: {
      eyebrow: "Candidature",
      title: "INSTALLEZ VOTRE EXPERTISE AU CŒUR DU SANCTUAIRE DE LA SÉRÉNITÉ™",
      body:
        "Vous êtes un cabinet de soins d'élite, une clinique médico-esthétique d'avant-garde ou une marque de neuro-cosmétique indépendante ? Les espaces pour The Avenue of Specialists™ sont strictement limitées à seulement 30 alcôves privées en verre givré pour préserver la Stature d'exception et assurer un trafic fluide à haute valeur transactionnelle. Remplissez notre formulaire de sélection. Notre direction générale évaluera la synergie de votre structure en moins de 48 heures.",
      programLabel: "The Avenue of Specialists™",
      categoryOptions: [
        "Cabinet de soins d'élite",
        "Clinique médico-esthétique",
        "Marque de neuro-cosmétique",
        "Spécialiste du bien-être",
        "Sponsor Corporatif",
      ],
    },
  },
  editions: {
    title: "ÉDITIONS 2027 — LES RÉSIDENCES ANNUELLES",
    subtitle:
      "Quatre résidences. Quatre disciplines. Une seule signature. Découvrez nos teasers mystères — les indices se dévoilent au fil de l'année.",
    cardLabel: "TEASER MYSTÈRE",
    cardLockedTitle: "Bientôt dévoilé",
    cardLockedBody: "Le rideau se lève bientôt. Restez à l'écoute.",
    cards: [
      { id: "ed-01", code: "RÉSIDENCE I", hint: "Mode · Hiver" },
      { id: "ed-02", code: "RÉSIDENCE II", hint: "Sport · Printemps" },
      { id: "ed-03", code: "RÉSIDENCE III", hint: "Culture urbaine · Été" },
      { id: "ed-04", code: "RÉSIDENCE IV", hint: "Philanthropie · Automne" },
      { id: "ed-05", code: "RÉSIDENCE V", hint: "Hors-série" },
    ],
    prev: "Carte précédente",
    next: "Carte suivante",
  },

  ticketing: {
    title: "BILLETTERIE",
    body: "La vente de billets se déroulera via notre partenaire sécurisé Zeffy. Disponible bientôt.",
  },

  partners: {
    eyebrow: "Candidature",
    title: "DEVENEZ ACTEUR DE L'AVANT-GARDE URBAINE",
    body:
      "Que vous soyez une marque visionnaire désireuse de sceller un partenariat d'ancrage, un créateur indépendant prêt à intégrer notre consortium, ou un passionné en quête d'une immersion sensorielle inédite, GEM Entertainment™ Inc. ouvre ses couloirs d'affaires. Nos résidences et franchises d'élite redéfinissent les standards du prestige et de l'impact culturel à Montréal. Communiquez avec notre direction pour évaluer nos synergies de structure.",
    fields: {
      company: { label: "Nom de l'entreprise", placeholder: "Studio, marque, friperie…" },
      contact: { label: "Nom du contact", placeholder: "Prénom Nom" },
      email: { label: "Courriel", placeholder: "vous@exemple.com" },
      phone: { label: "Numéro de téléphone", placeholder: "+1 (___) ___-____" },
      link: { label: "Lien Instagram / Site Web", placeholder: "instagram.com/votremarque (optionnel)" },
      category: {
        label: "Catégorie",
        placeholder: "Sélectionner une catégorie",
        options: [
          "Marque de vêtements",
          "Friperie",
          "Accessoires",
          "Artiste",
          "Sponsor Corporatif",
        ],
      },
    },
    submit: "Soumettre ma candidature",
    submitting: "Envoi en cours…",
    successTitle: "Merci !",
    successBody:
      "Votre candidature a bien été reçue. Notre équipe vous contactera sous 48 h.",
    successReset: "Soumettre une autre candidature",
    errorGeneric: "Une erreur est survenue. Réessayez dans un instant.",
    errors: {
      required: "Ce champ est requis",
      email: "Courriel invalide",
      phone: "Numéro de téléphone invalide",
      url: "Lien invalide",
    },
  },

  footer: {
    tagline: "Nous créons les traditions de demain",
    socials: {
      instagram: "Instagram",
      tiktok: "TikTok",
    },
    contact: "contact@gementertainment.ca",
    copyright: "© 2026 GEM ENTERTAINMENT. Tous droits réservés.",
    legal: ["Mentions légales", "Confidentialité"],
  },
};

export default fr;
